import {React, useEffect} from 'react';

export default function MFACode({ setParentCode, loadingSpinner, setLoadingSpinner }) {
    
    let code = "";

    const handleInputChange = (e, index) => {
        readInputs()
        const input = e.target;
        const nextInput = input.nextSibling;

        if (input.value.length === 1 && nextInput) {
            nextInput.focus();
        }

        if (index === 5 && input.value.length === 1) {
            updateCode(code);
        }
    };

    const readInputs = () => {
        const inputs = document.querySelectorAll('input[type="text"]');
        let codeString = '';
        inputs.forEach((input) => {
            codeString += input.value;
        });
        code = codeString;
    };

    const handleKeyDown = (e, index) => {
        const input = e.target;
        const prevInput = input.previousSibling;
        const nextInput = input.nextSibling;

        if (e.key === 'Backspace' && input.value.length === 0 && prevInput) {
            prevInput.focus();
        } else if (e.key === 'Delete' && input.value.length === 0 && nextInput) {
            nextInput.focus();
        }
    };
    
    const handlePaste = (e) => {
        const pastedData = e.clipboardData.getData('text/plain');
        const numbersOnly = pastedData.replace(/[^\d]/g, '');
        const firstSixDigits = numbersOnly.slice(0, 6);
        
        const inputs = document.querySelectorAll('input[type="text"]');
        inputs.forEach((input, index) => {
            if (index < firstSixDigits.length) {
                input.value = firstSixDigits[index];
            } else {
                input.value = '';
            }
        });
        code = firstSixDigits;
        updateCode(firstSixDigits)
    };

    function handleSignInViaButton() {
        readInputs();
        updateCode(code);
    }

    function updateCode(codeString) {
        setLoadingSpinner(true);
        setParentCode(codeString);
    }

    useEffect(() => {
        const firstInput = document.getElementById(0);
        if (firstInput) {
            firstInput.focus();
        }
    }, []);

    return (
        <>
        <div className="flex gap-1 justify-center">
            <input
                id={0}
                type="text"
                className="bg-white/5 w-14 h-14 text-xl text-center border border-2 rounded-md border-gray-300"
                maxLength={1}
                onChange={(e) => handleInputChange(e, 0)}
                onKeyDown={(e) => handleKeyDown(e, 0)}
                onPaste={handlePaste}
                inputMode='numeric'
                autoComplete='off'
            />
            <input
                id={1}
                type="text"
                className="bg-white/5 w-14 h-14 text-xl text-center border border-2 rounded-md border-gray-300"
                maxLength={1}
                onChange={(e) => handleInputChange(e, 1)}
                onKeyDown={(e) => handleKeyDown(e, 1)}
                onPaste={handlePaste}
                inputMode='numeric'
                autoComplete='off'
            />
            <input
                id={2}
                type="text"
                className="bg-white/5 w-14 h-14 text-xl text-center border border-2 rounded-md border-gray-300"
                maxLength={1}
                onChange={(e) => handleInputChange(e, 2)}
                onKeyDown={(e) => handleKeyDown(e, 2)}
                onPaste={handlePaste}
                inputMode='numeric'
                autoComplete='off'
            />
            <input
                id={3}
                type="text"
                className="bg-white/5 w-14 h-14 text-xl text-center border border-2 rounded-md border-gray-300"
                maxLength={1}
                onChange={(e) => handleInputChange(e, 3)}
                onKeyDown={(e) => handleKeyDown(e, 3)}
                onPaste={handlePaste}
                inputMode='numeric'
                autoComplete='off'
            />
            <input
                id={4}
                type="text"
                className="bg-white/5 w-14 h-14 text-xl text-center border border-2 rounded-md border-gray-300"
                maxLength={1}
                onChange={(e) => handleInputChange(e, 4)}
                onKeyDown={(e) => handleKeyDown(e, 4)}
                onPaste={handlePaste}
                inputMode='numeric'
                autoComplete='off'
            />
            <input
                id={5}
                type="text"
                className="bg-white/5 w-14 h-14 text-xl text-center border border-2 rounded-md border-gray-300"
                maxLength={1}
                onChange={(e) => handleInputChange(e, 5)}
                onKeyDown={(e) => handleKeyDown(e, 5)}
                onPaste={handlePaste}
                inputMode='numeric'
                autoComplete='off'
            />
        </div>
        
        <div className="flex justify-center">
            <p className="mt-8 text-center text-gray-400">We have emailed you a multi-factor authentication code. <br/> Please enter the code to login.</p>
        </div>
        <div className="flex justify-center">
            {loadingSpinner ?
                <button type='button' className="flex w-20 mt-8 h-8 content-center justify-center rounded-md bg-blue-700 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700">
                    <div>
                        <svg aria-hidden="true" className="w-6 h-4 mt-0.5 content-center justify-center text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                        </svg>
                    </div>
                </button>
            :
                <button type='button' onClick={() => {handleSignInViaButton()}} className="mt-8 h-8 w-20 flex content-center justify-center rounded-md bg-blue-700 px-3 py-1 text-sm font-semibold leading-6 text-white hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700">
                    Sign in
                </button>
            }
        </div>
        
        </>
    );
}